import axios from './axios'
import store from '@/store/index';
import router from "@/router";
import { getStorage, setStorage } from "@/common/utils/storage.js";
import { MessageBox, Message } from 'element-ui'
// import axios from 'axios'
const PROTOCOL = window.location.protocol || 'http';
export const DOMAIN = {
  'TOPS': {
    // development: 'http://118.178.135.136:8081',
    // development: `${PROTOCOL}//tops2-test.ehsy.com`,
    development: `https://devops-test.ehsy.com`,
    production: `${PROTOCOL}//devops.ehsy.com`
  },
  'DMS': {
    // development: 'http://192.168.54.252:8080',
    development: `${PROTOCOL}//dmsbc-test.ehsy.com`,
    production: `${PROTOCOL}//dmsbc.ehsy.com`
  },
  'RISKCONTROL': {
    development: `${PROTOCOL}//gofast-test.ehsy.com`,
    production: `${PROTOCOL}//gofast-test.ehsy.com`
  },
  'HOME':{
    development: `${PROTOCOL}//sso-test.ehsy.com`,
    production: `${PROTOCOL}//sso.ehsy.com`
  },
}

const throwError = (err) => {
  let message = ''
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        message = '请求错误'
        break
      case 401:
       message = '未授权，请登录'
        break
      case 403:
        message = '拒绝访问'
        break
      case 404:
        message = `请求地址出错: ${err.response.config.url}`
        break
      case 408:
        message = '请求超时'
        break
      case 500:
        message = '服务器内部错误'
        break
      case 501:
        message = '服务未实现'
        break
      case 502:
        message = '网关错误'
        break
      case 503:
        message = '服务不可用'
        break
      case 504:
        message = '网关超时'
        break
      case 505:
        message = 'HTTP版本不受支持'
        break
      default:
    }
  }
  return message || err?.message || err;
}

export function axiosPost(url = '', params, type = 'TOPS', headers = {},) {
  const token = getStorage('token', 'localStorage');
   if(!token && type !='noLogin'){
     router.push({
       path: '/login'
   })
   const result = {response:{status:401}};
   throwError(result)
   }
   if(type !='noLogin'){
    headers.token = token;
   }
   let r_type = 'TOPS';
   if(DOMAIN[type]){
     r_type = type;
   }
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
        url: url.startsWith('http') || url.startsWith('https') ? url : DOMAIN[r_type][process.env.NODE_ENV] + url,
        method: 'post',
        params,
        headers
      })
      if(res.data.message == 'token认证失败'  || res.data.message == 'token已失效' || res.data.message == '非法的token'){
        router.push({
          path: '/login'
        })
        return false
      }
      if (res && res.status === 200) {
        resolve(res.data || {})
      } else {
        reject(JSON.stringify(res) || '未获取到数据')
      }
    } catch (err) {
      reject(err)
    }
  })
}

export function axiosGet(url = '', params, type = 'TOPS', headers = {},) {
  const token = getStorage('token', 'localStorage');
   if(!token && type !='noLogin'){
      router.push({
        path: '/login'
    })
   const result = {response:{status:401}};
   throwError(result)
   }
   if(type !='noLogin'){
    headers.token = token;
   }
  let r_type = 'TOPS';
  if(DOMAIN[type]){
    r_type = type;
  }
  /*以下两行代码暂时解决查看端口环境占用 跨域问题*/
  if(url.includes('https://tops2-static.ehsy.com/config')){
    url = '/devops/service_relations?url='+url;
  }
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
        url: url.startsWith('http') || url.startsWith('https') ? url : DOMAIN[r_type][process.env.NODE_ENV] + url,
        method: 'get',
        params,
        headers
      })
      if(res.data.message == 'token认证失败' || res.data.message == 'token已失效' || res.data.message == '非法的token'){
        router.push({
          path: '/login'
        })
        return false
      }
      if (res && res.status === 200) {
        resolve(res.data || {})
      } else {
        reject(JSON.stringify(res) || '未获取到数据')
      }
    } catch (err) {
      return Promise.reject(throwError(err))
    }
  })
}

export function axiosDelete(url = '', params, type = 'TOPS', headers = {},) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axios({
        url: url.startsWith('http') || url.startsWith('https') ? url : DOMAIN[type][process.env.NODE_ENV] + url,
        method: 'delete',
        params,
        headers
      })
      if (res && res.status === 200) {
        resolve(res.data || {})
      } else {
        reject(JSON.stringify(res) || '未获取到数据')
      }
    } catch (err) {
      return Promise.reject(throwError(err))
    }
  })
}

export async function axiosGetDetail(url = '', params, type = 'TOPS', headers = {},) {
  const token = getStorage('token', 'localStorage');
  if (!token && type != 'noLogin') {
    router.push({
      path: '/login'
    })
    const result = {response: {status: 401}};
    throwError(result)
  }
  if (type != 'noLogin') {
    headers.token = token;
  }
  let r_type = 'TOPS';
  if (DOMAIN[type]) {
    r_type = type;
  }
  const res = await axios({
    url: url.startsWith('http') || url.startsWith('https') ? url : DOMAIN[r_type][process.env.NODE_ENV] + url,
    method: 'get',
    params,
    headers
  })
  return res;
}
